"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;
var _styles = require("@material-ui/core/styles");
var _styles2 = require("@material-ui/styles");
var _clsx = _interopRequireDefault(require("clsx"));
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["children", "value", "onChange", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex"
    },
    btnDiv: _objectSpread({
      borderRadius: 0,
      minWidth: 90,
      padding: "7px 13px"
    }, theme.direction === "rtl" ? {
      borderRightWidth: 0,
      "&:hover": {
        borderRightWidth: 0
      },
      "&:first-child": {
        borderRightWidth: 1,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10
      },
      "&:last-child": {
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10
      }
    } : {
      borderLeftWidth: 0,
      "&:hover": {
        borderLeftWidth: 0
      },
      "&:first-child": {
        borderLeftWidth: 1,
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10
      },
      "&:last-child": {
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10
      }
    }),
    disabled: {
      backgroundColor: "".concat(_pittaModules.LightColors.primary["7"], "!important")
    }
  };
});
var ButtonGroup = function ButtonGroup(props) {
  var classes = useStyles();
  var theme = (0, _styles2.useTheme)();
  var children = props.children,
    value = props.value,
    onChange = props.onChange,
    className = props.className,
    restProps = _objectWithoutProperties(props, _excluded);
  _react.default.Children.map(children, function (child, index) {
    if (! /*#__PURE__*/_react.default.isValidElement(child)) {
      return;
    }
  });
  var items = _react.default.Children.map(children, function (child, index) {
    if (!child) {
      return undefined;
    }
    if (index === value) {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        variant: "contained",
        color: "primary",
        disabled: true,
        className: (0, _clsx.default)(classes.btnDiv, classes.disabled),
        onClick: function onClick() {
          return onChange(index);
        }
      });
    } else {
      return /*#__PURE__*/_react.default.cloneElement(child, {
        variant: "outlined",
        color: "primary",
        className: classes.btnDiv,
        onClick: function onClick() {
          return onChange(index);
        }
      });
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    dir: theme.direction,
    className: (0, _clsx.default)(classes.root, className)
  }, restProps), _lodash.default.compact(items));
};
exports.ButtonGroup = ButtonGroup;